<template>
  <div class="content">
    <b-tabs content-class="mt-3">
      <b-tab active>
        <template slot="title">
          <i class="si si-user"></i> {{ $t('users.info') }}
        </template>
        <admin-user-edit v-if="adminUser.id" />
      </b-tab>
      <b-tab>
        <template slot="title">
          <i class="fa fa-line-chart"></i> {{ $t('users.stats') }}
        </template>
        <admin-comments-linechart :user-id="user_id" />
        <admin-payments-linechart :user-id="user_id" />
        <admin-debts-stats-doughnutchart :user-id="user_id" />
      </b-tab>
      <b-tab v-if="permissions.indexOf('distribution-debts') != -1">
        <template slot="title">
          <font-awesome-icon icon="file-contract" /> {{ $t('debts.distribute') }}
        </template>
        <admin-distribute-debts/>
      </b-tab>
      <b-tab v-if="permissions.indexOf('read-acl') != -1" >
        <template slot="title">
          <font-awesome-icon icon="chess" /> {{ $t('permissions.index') }}
        </template>
        <admin-permissions/>
      </b-tab>
      <b-tab>
        <template slot="title">
          <font-awesome-icon :icon="['far', 'id-card']" /> {{ $t('users.activities') }}
        </template>
        <admin-activities/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AdminUserEdit from '@/components/admin/users/edit.vue';

export default {
  data() {
    return {
      user_id: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters([
      'adminUser',
      'permissions',
    ]),
  },
  mounted() {
    this.GET_ADMIN_USER(this.$route.params.id);
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_USER',
    ]),
  },
  components: {
    AdminUserEdit,
    AdminPaymentsLinechart: () => import('@/components/admin/charts/lineChart/payments.vue'),
    AdminCommentsLinechart: () => import('@/components/admin/charts/lineChart/comments.vue'),
    AdminDebtsStatsDoughnutchart: () => import('@/components/admin/charts/doughnutChart/debtsStats.vue'),
    AdminDistributeDebts: () => import('@/components/admin/users/selectdebtor.vue'),
    AdminPermissions: () => import('@/components/admin/users/permissions.vue'),
    AdminActivities: () => import('@/components/admin/users/activities.vue'),
  },
};
</script>
